import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { useField } from 'formik';
import ValidationWrapper from './helpers/ValidationWrapper';
import styles from './InputField.module.scss';

interface IProps {
  name: string;
  placeholder: string;
  type: string;
  loading?: boolean;
  autoComplete?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  pattern?: string;
  min?: number;
}

export const InputField: FunctionComponent<IProps> = ({ ...props }) => {
  const [field, meta] = useField(props);
  const { loading, disabled, autoComplete, placeholder, type, pattern, ...cleanedProps } = props;

  const { value, onChange, onBlur } = field;

  return (
    <div className={styles.container}>
      <ValidationWrapper error={meta.error} touched={meta.touched}>
        <Input
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          disabled={loading || disabled}
          autoComplete={autoComplete}
          placeholder={placeholder}
          type={type}
          name={props.name}
          pattern={pattern}
          data-testid={`${props.name}-Input`}
          {...cleanedProps} // Remove this to get submit working
        />
      </ValidationWrapper>
    </div>
  );
};

InputField.propTypes = {
  name: PropTypes.string.isRequired,
};

export default InputField;
